import gql from 'graphql-tag';
import { apolloClient } from '~/plugins/apollo';
import { CORE_DEVICE_TYPE_FIELDS, CORE_MACHINE_COUNT_TYPE_FIELDS } from '~/graphql/fragments';

// state
export const state = {
  deviceTypes: [],
  deviceTypesAreLoaded: false,
  deviceTypesAreLoading: false,
};

// getters
export const getters = {
  getDeviceTypes: (state) => state.deviceTypes,
};

// mutations
export const mutations = {
  commitDeviceTypes(state, data) {
    state.deviceTypes = data;
  },
  commitDeviceTypesAreLoaded(state, b) {
    state.deviceTypesAreLoaded = b;
  },
  commitDeviceTypesAreLoading(state, b) {
    state.deviceTypesAreLoading = b;
  },
};

// actions
export const actions = {
  /**
   * Fetch the Device Types from API
   * @param context
   */
  async fetchDeviceTypes(context) {
    if (context.state.deviceTypesAreLoading || context.state.deviceTypesAreLoaded) {
      return;
    }
    context.commit('commitDeviceTypesAreLoading', true);
    try {
      const { data } = await apolloClient.query({
        query: gql`
              query DeviceTypes {
                  deviceTypes {
                      data {
                          ...CoreDeviceTypeFields,
                          countingTypesExpand {
                              ...CoreMachineCountTypeFields
                          }
                      }
                  }
              }
              ${CORE_DEVICE_TYPE_FIELDS}
              ${CORE_MACHINE_COUNT_TYPE_FIELDS}
          `,
      });
      // The client reads with `errorPolicy: 'all'`: a refused query resolves without data.
      if (!data?.deviceTypes?.data) {
        throw new Error('The device types query returned no data');
      }
      context.commit('commitDeviceTypes', data.deviceTypes.data);
      context.commit('commitDeviceTypesAreLoaded', true);
    } finally {
      // Release the guard even on failure, otherwise no later call would ever retry.
      context.commit('commitDeviceTypesAreLoading', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
